import React, { useContext } from 'react';
import { FormContext } from '../FormContext.jsx';
import { isAdminApp } from '../../../public/lib/PageHelpers.js';
import QuestionLabel from './QuestionLabel';
import EmailInput from '../../EmailInput.jsx';
import ShowPackageBalance from '~/components/forms/questions/components/ShowPackageBalance.jsx';

const SingleGuest = ({ value, setValue, settings, labelPrefix, idx }) => {
    const labelSuffix = idx > 0 ? idx + 1 : '';
    const isFirst = idx === 0;
    const effectiveSettings = !isFirst
        ? settings
        : { ...settings, required: true /*always requried!*/ };

    return (
        <div className="mb-4">
            <QuestionLabel
                label={`${labelPrefix} Name ${labelSuffix}`}
                settings={effectiveSettings}
            />
            <input
                type="text"
                placeholder=""
                className="mr-4"
                value={value?.name || ''}
                onChange={e => setValue({ ...value, name: e.target.value })}
            />

            <QuestionLabel
                label={`${labelPrefix} Email ${labelSuffix}`}
                settings={effectiveSettings}
                className="mt-4"
            />
            <EmailInput
                value={value?.email || ''}
                onChange={newValue => setValue({ ...value, email: newValue })}
            />
            {isFirst && (
                <ShowPackageBalance
                    settings={settings}
                    email={value?.email}
                    name={value?.name}
                />
            )}
        </div>
    );
};

const ContactInfoQuestion = ({ label, value, setValue, settings }) => {
    const formContext = useContext(FormContext);

    // Default to 0 guests, or 1 if it's the admin app so we show some preview
    const contactQuantity = !!settings.disableGuestEntry
        ? 1
        : formContext?.eventQuantity || 1;

    value = value || [];

    return (
        <div>
            {[...Array(contactQuantity)].map((num, idx) => (
                <SingleGuest
                    key={idx}
                    labelPrefix={settings?.labelPrefix || ''}
                    idx={idx}
                    settings={settings}
                    value={value[idx] || {}}
                    setValue={newSingleValue => {
                        const newValue = [...value];
                        newValue[idx] = newSingleValue;
                        setValue(newValue);
                    }}
                />
            ))}
        </div>
    );
};

export default ContactInfoQuestion;
